/*
  Verificateur de compatibilite, sous le bouton panier des fiches keycaps.

  Deux clics : la taille du clavier, puis sa disposition. Le verdict sort du referentiel,
  pousse en metafields `ctc_compat` sur la fiche et lu ici dans des attributs data.

  REGLE : ce composant n'affirme QUE ce que le referentiel prouve. Quand la preuve manque,
  il le dit et propose les sets dont le kitting a ete lu. Il ne devine jamais.
*/
(function () {
  'use strict';

  var TAILLES = [
    { cle: '60', libelle: '60%' },
    { cle: '65', libelle: '65%' },
    { cle: '75', libelle: '75%' },
    { cle: 'tkl', libelle: 'TKL / 80%' },
    { cle: '100', libelle: 'Pleine taille' }
  ];
  var DISPOS = [
    { cle: 'iso', libelle: 'ISO', aide: 'Entrée en L, touche &lt; &gt; à gauche du W' },
    { cle: 'ansi', libelle: 'ANSI', aide: 'Entrée rectangulaire, pas de touche &lt; &gt;' }
  ];
  var COMPACT = { '65': 1, '75': 1 };

  /*
    Le verdict, etat par etat.

    OUI          la preuve porte sur ce cas
    INCERTAIN    on ne sait pas : on le dit, et on propose ce qui est prouve
    NON          l'inventaire a ete lu et la piece manque
  */
  function verdict(etat, taille, dispo) {
    if (etat === 'COMPATIBLE_65_75') {
      return {
        cle: 'oui',
        titre: 'Oui, ce set va sur ton clavier.',
        detail: COMPACT[taille]
          ? 'Son visuel de kitting montre le Shift droit <strong>1,75u</strong> qu\'exige ce format, ' +
            'et les pièces de forme ANSI. Vérifié pièce par pièce.'
          : 'Il porte une base ANSI complète et les pièces ISO en supplément. ' +
            'Vérifié pièce par pièce sur son visuel de kitting.'
      };
    }
    if (etat === 'COMPATIBLE_60_SEULEMENT') {
      if (COMPACT[taille]) {
        return {
          cle: 'non',
          titre: 'Non, il manque une pièce.',
          detail: 'Ce format demande un Shift droit <strong>1,75u</strong>. Sur ce set, la ' +
                  'touche de 1,75u est une novelty, et le Shift légendé fait 2u.'
        };
      }
      if (dispo === 'ansi') {
        return {
          cle: 'oui',
          titre: 'Oui, en ANSI.',
          detail: 'Sa base ANSI est complète, elle couvre ce format.'
        };
      }
      return incertain('Sa base ANSI est complète, mais les pièces ISO n\'ont pas été relevées sur son visuel.');
    }
    if (etat === 'NON_COMPATIBLE') {
      if (dispo === 'iso') {
        return {
          cle: 'oui',
          titre: 'Oui, sur un clavier ISO.',
          detail: 'Son inventaire a été lu : Entrée ISO en L, touche &lt; &gt;, et même un ' +
                  'Shift droit 1,75u pour les formats compacts.'
        };
      }
      return {
        cle: 'non',
        titre: 'Non, pas sur un kit ANSI.',
        detail: 'Son inventaire a été lu : il n\'a ni Shift gauche 2,25u ni Entrée ANSI 2,25u. ' +
                'Il reste ISO sur les positions structurantes.'
      };
    }
    // NON_PROUVE, NON_PROUVABLE, NON_INSTRUIT
    if (dispo === 'iso' && !COMPACT[taille]) {
      return {
        cle: 'oui',
        titre: 'Oui, sur ce format en ISO.',
        detail: 'C\'est un set AZERTY ISO FR pleine taille : Entrée en L, Shift gauche court, ' +
                'touche &lt; &gt;. Il couvre un clavier ISO pleine taille et un 60% ISO.'
      };
    }
    if (COMPACT[taille]) {
      return incertain('Ce format demande un Shift droit <strong>1,75u</strong>, et un kit ANSI ' +
                       'demande en plus une Entrée et un Shift gauche de forme ANSI. Le visuel de ' +
                       'kitting de ce set ne permet pas de l\'affirmer.');
    }
    return incertain('Un kit ANSI demande une Entrée et un Shift gauche de forme ANSI. Le visuel ' +
                     'de kitting de ce set ne permet pas de l\'affirmer.');
  }

  function incertain(detail) {
    return {
      cle: 'incertain',
      titre: 'On ne peut pas te le garantir.',
      detail: detail,
      alternatives: true
    };
  }

  function bouton(cle, libelle, aide) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ctc-vc__choix';
    b.dataset.valeur = cle;
    b.innerHTML = aide
      ? '<span class="ctc-vc__choix-nom">' + libelle + '</span>' +
        '<span class="ctc-vc__choix-aide">' + aide + '</span>'
      : libelle;
    return b;
  }

  function Verificateur(racine) {
    this.racine = racine;
    this.etat = racine.dataset.etat || 'NON_INSTRUIT';
    this.taille = null;
    this.dispo = null;
    this.urlSets = racine.dataset.setsUrl || '';
    this.handle = racine.dataset.handle || '';
    this.rendre();
  }

  Verificateur.prototype.rendre = function () {
    var self = this;
    var r = this.racine;
    r.innerHTML = '';

    var titre = document.createElement('p');
    titre.className = 'ctc-vc__titre';
    titre.innerHTML = '<strong>Ce set va-t-il sur ton clavier ?</strong>';
    r.appendChild(titre);

    var etape1 = this.etape('Sa taille', TAILLES, function (v) {
      self.taille = v;
      self.rendre();
      var e2 = self.racine.querySelector('[data-etape="2"] .ctc-vc__choix');
      if (e2) { e2.focus(); }
    }, this.taille);
    etape1.dataset.etape = '1';
    r.appendChild(etape1);

    if (this.taille) {
      var etape2 = this.etape('Sa disposition', DISPOS, function (v) {
        self.dispo = v;
        self.rendre();
      }, this.dispo);
      etape2.dataset.etape = '2';
      r.appendChild(etape2);
    }

    if (this.taille && this.dispo) {
      this.afficherVerdict(verdict(this.etat, this.taille, this.dispo));
    }
  };

  Verificateur.prototype.etape = function (legende, options, auClic, choisi) {
    var bloc = document.createElement('div');
    bloc.className = 'ctc-vc__etape';
    var l = document.createElement('span');
    l.className = 'ctc-vc__legende';
    l.textContent = legende;
    bloc.appendChild(l);
    var ligne = document.createElement('div');
    ligne.className = 'ctc-vc__choix-ligne';
    options.forEach(function (o) {
      var b = bouton(o.cle, o.libelle, o.aide);
      if (choisi === o.cle) { b.classList.add('is-choisi'); }
      b.addEventListener('click', function () { auClic(o.cle); });
      ligne.appendChild(b);
    });
    bloc.appendChild(ligne);
    return bloc;
  };

  Verificateur.prototype.afficherVerdict = function (v) {
    var boite = document.createElement('div');
    boite.className = 'ctc-vc__verdict ctc-vc__verdict--' + v.cle;
    boite.setAttribute('role', 'status');
    boite.innerHTML = '<p class="ctc-vc__verdict-titre">' + v.titre + '</p>' +
                      '<p class="ctc-vc__verdict-detail">' + v.detail + '</p>';
    if (v.cle !== 'oui') {
      var aide = document.createElement('p');
      aide.className = 'ctc-vc__verdict-detail';
      aide.innerHTML = 'Un doute ? <a href="/pages/contact">Envoie-nous le modèle de ton ' +
                       'clavier</a>, on te confirme avant que tu commandes.';
      boite.appendChild(aide);
    }
    this.racine.appendChild(boite);
    if (v.alternatives) { this.proposerAlternatives(boite); }
  };

  /* Le produit qui passe quand celui-ci ne passe pas. */
  Verificateur.prototype.proposerAlternatives = function (boite) {
    var self = this;
    if (!this.urlSets) { return; }
    fetch(this.urlSets, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.sets || !d.sets.length) { return; }
        var autres = d.sets.filter(function (s) { return s.handle !== self.handle; });
        if (!autres.length) { return; }
        var bloc = document.createElement('div');
        bloc.className = 'ctc-vc__alternatives';
        var t = document.createElement('p');
        t.className = 'ctc-vc__verdict-detail';
        t.innerHTML = '<strong>' + autres.length + ' sets ont été vérifiés pièce par pièce</strong> ' +
                      'pour les 65% et les 75% :';
        bloc.appendChild(t);
        var bande = document.createElement('div');
        bande.className = 'ctc-vc__bande';
        autres.forEach(function (s) {
          var a = document.createElement('a');
          a.href = '/products/' + s.handle;
          a.className = 'ctc-vc__tuile';
          a.innerHTML = '<img src="' + s.image + '" alt="Visuel de kitting : ' + s.titre +
                        '" loading="lazy" width="88" height="88">' +
                        '<span>' + s.nom + '</span>';
          bande.appendChild(a);
        });
        bloc.appendChild(bande);
        boite.appendChild(bloc);
      })
      .catch(function () { /* pas d'alternatives : le renvoi au contact suffit */ });
  };

  function demarrer() {
    var noeuds = document.querySelectorAll('[data-ctc-verificateur]:not([data-pret])');
    for (var i = 0; i < noeuds.length; i++) {
      noeuds[i].dataset.pret = '1';
      new Verificateur(noeuds[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  document.addEventListener('shopify:section:load', demarrer);

  // Expose la regle pour pouvoir la tester hors boutique.
  window.ctcVerdictCompat = verdict;
})();
